// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"5e138b5544e77529","5285":"3c256ee41c9cd862"}[chunkId] + ".css";
};